export default __webpack_public_path__ + "static/media/zertiassist_iconos_levels_24px.2025e98f.svg";